import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@suvo-bi-lib';
import { NavigationOutletComponent } from './components/navigation-outlet/navigation-outlet.component';

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [NavigationOutletComponent],
  exports: [NavigationOutletComponent],
})
export class NavigationOutletModule {}
